import { RouterView } from "vue-router";
import { WarehouseRouting } from "./warehouse/warehouse.routing";
import { ExWarehouseRouting } from "./ex-warehouse/ex-warehouse.routing";
import { OtherWarehouseRouting } from "./other-warehouse/other-warehouse.routing";
import { OtherExWarehouseRouting } from "./other-ex-warehouse/other-ex-warehouse.routing";
import { RequisitionRouting } from "./requisition/requisition.routing";
import { MaterialReturnRouting } from "./material-return/material-return.routing";
import { ApplyRouting } from "@/views/purchase/apply/apply.routing";
import { ManageRouting } from "@/views/material/manage/manage.routing";
import { ManualInventoryRouting } from "./manual-inventory/manual-inventory.routing";


export const MaterialRouting = {
  path: "/material",
  name: "basic-material",
  redirect: "/purchase/apply/list",
  component: RouterView,
  meta: { title: "材料管理", icon: "cailiao" },
  children: [
    ...ApplyRouting,
    // ...CategoryRouting,
    // ...BrandRouting,
    // ...LibraryRouting,
    // ...RepoRouting,
    // ...UnitRouting,
    // ...AccessManagementRouting,
    ...ManageRouting,
    ...RequisitionRouting,
    ...MaterialReturnRouting,
    ...WarehouseRouting,
    ...ExWarehouseRouting,
    ...OtherWarehouseRouting,
    ...OtherExWarehouseRouting,
    ...ManualInventoryRouting
  ],
};
